import { Link, useLocation, useNavigate } from "react-router-dom";
import { Terminal, LibraryBig, Settings2, LogOut, ArrowRight } from "lucide-react";
import { useAuth } from "@agent/context/AuthContext";

const NAV = [
  { to: "/agent", label: "Composer", icon: Terminal },
  { to: "/agent/library", label: "Library", icon: LibraryBig },
  { to: "/agent/settings", label: "Settings", icon: Settings2 },
];

export function Layout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f6f8fb] text-[#0f172a] flex flex-col">
      <div className="sticky top-0 z-40 px-4 pt-4">
        <header className="max-w-6xl mx-auto bg-white/95 backdrop-blur border border-slate-200 rounded-full shadow-[0_2px_20px_rgba(15,23,42,0.06)]">
          <div className="flex items-center justify-between pl-6 pr-2 h-14">
            <div className="flex items-center gap-8">
              <Link to="/agent" data-testid="app-logo" className="flex items-center gap-2.5">
                <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-violet-500 flex items-center justify-center text-white font-bold text-sm font-display">T</span>
                <span className="leading-none">
                  <span className="block font-display font-bold text-[15px] text-[#0f172a]">TechPost</span>
                  <span className="block text-[9px] tracking-[0.25em] uppercase text-slate-400 font-medium">Agent</span>
                </span>
              </Link>
              <nav className="hidden sm:flex items-center gap-1">
                {NAV.map(({ to, label, icon: Icon }) => {
                  const active = to === "/agent" ? loc.pathname === "/agent" || loc.pathname.startsWith("/agent/composer") : loc.pathname === to;
                  return (
                    <Link key={to} to={to} data-testid={`nav-${label.toLowerCase()}`}
                      className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-150 ${
                        active ? "bg-slate-100 text-[#0f172a]" : "text-slate-500 hover:text-[#0f172a]"}`}>
                      <Icon size={15} /> {label}
                    </Link>
                  );
                })}
              </nav>
            </div>
            <div className="flex items-center gap-3">
              <span data-testid="user-email" className="hidden md:block text-xs text-slate-400">{user?.email}</span>
              <button data-testid="logout-btn" onClick={() => { logout(); navigate("/agent/login"); }}
                className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#0f172a] text-white text-sm font-medium hover:bg-[#1e293b] transition-colors duration-150">
                Sign out <LogOut size={14} />
              </button>
            </div>
          </div>
        </header>
      </div>
      <main className="flex-1">{children}</main>
    </div>
  );
}
